import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { formatEuro } from "@shared/geld";

export interface ItemRowProps {
  title: ReactNode;
  /** Foto-URL; `false` blendet das Foto aus. */
  photo?: string | false;
  photoAlt?: string;
  meta?: ReactNode;
  /** Preis in Cent oder fertiges Element. */
  price?: number | ReactNode;
  status?: ReactNode;
  action?: ReactNode;
  tone?: "attention" | "error" | "joy";
  selected?: boolean;
  className?: string;
  onClick?: () => void;
}

/** Eine Zeile für Artikel in Warenkorb, Meine Artikel und Verkäufen. Mindesthöhe 72 px, Foto 56 px, Preis rechts. */
export function ItemRow({ title, photo, photoAlt = "", meta, price, status, action, tone, selected, className, onClick }: ItemRowProps) {
  const cls = ["rg-row", tone && `rg-row--${tone}`, selected && "is-selected", onClick && "rg-row--click", className].filter(Boolean).join(" ");
  const inhalt = (
    <>
      {photo === false ? null : photo ? (
        <img className="rg-thumb" src={photo} alt={photoAlt} loading="lazy" />
      ) : (
        <span className="rg-thumb rg-thumb--empty" aria-hidden="true">
          <Icon name="image-off" size={22} />
        </span>
      )}
      <div className="rg-row__main">
        <div className="rg-row__title">{title}</div>
        {meta ? <div className="rg-row__meta">{meta}</div> : null}
        {status ? <div className="rg-row__status">{status}</div> : null}
      </div>
      {price !== undefined ? <div className="rg-row__price">{typeof price === "number" ? formatEuro(price) : price}</div> : null}
      {action ? <div className="rg-row__action">{action}</div> : null}
    </>
  );
  if (onClick) {
    return (
      <div className={cls} role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), onClick())}>
        {inhalt}
      </div>
    );
  }
  return <div className={cls}>{inhalt}</div>;
}
